






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { ReferralAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'

@Component
export default class LeadCrumb extends Vue {
    @Prop() readonly route!: Route
    @Prop() readonly last!: boolean
    referral: Referral = null

    async mounted() {
        this.referral = await ReferralAPI.get(this.$route.params.referralId)
    }

    get show() {
        return this.referral && this.$currentCompany.pipelinesEnabled
    }

    get showVanilla() {
        return this.referral && !this.$currentCompany.pipelinesEnabled
    }

    get componentClasses(): object {
        return {
            'crumb': true,
            'crumb--last': this.last,
            'crumb--lead': true,
        }
    }
}

